export type Brand<T, TBrand extends string> = T & { readonly __brand: TBrand };

export type DateTimePrecision = 'minutes' | 'seconds' | 'milliseconds';

export const createError = (message: string): Error =>
  new Error(`[ltDate] ${message}`);

export const pad = (value: number, length = 2): string =>
  String(value).padStart(length, '0');
